import Loader from './Loader';
import Button from './Button';
import Header from './Header';
import Image from './custom/Image';
import ParsedText from './ParsedText';
import ReviewStars from './ReviewStars';
import OrderStatus from './OrderStatus';
import RatingStars from './RatingStars';
import OrderItem from './order/OrderItem';
import BlockHeading from './BlockHeading';
import KAScrollView from './KAScrollView';
import SmartView from './custom/SmartView';
import StatusBar from './custom/StatusBar';
import InputField from './custom/InputField';
import HomeIndicator from './custom/HomeIndicator';
import InputFieldBig from './custom/InputFieldBig';
import BurgerProfileItem from './BurgerProfileItem';
import ImageBackground from './custom/ImageBackground';
import LocationPickerModal from './LocationPickerModal';

// Product
import ProductNew from './product/ProductNew';
import ProductInCart from './product/ProductInCart';
import ProductInWishlist from './product/ProductInWishlist';

// Items
import FavoriteItem from './FavoriteItem';
import ReviewItem from './items/ReviewItem';
import MenuListItem from './items/MenuListItem';
import PromocodeItem from './items/PromocodeItem';
import RecommendedItem from './items/RecommendedItem';

export const components = {
  Image,
  Loader,
  Button,
  Header,
  OrderItem,
  SmartView,
  StatusBar,
  ProductNew,
  ParsedText,
  ReviewItem,
  InputField,
  OrderStatus,
  RatingStars,
  ReviewStars,
  MenuListItem,
  BlockHeading,
  KAScrollView,
  FavoriteItem,
  PromocodeItem,
  InputFieldBig,
  ProductInCart,
  HomeIndicator,
  RecommendedItem,
  ImageBackground,
  BurgerProfileItem,
  ProductInWishlist,
  LocationPickerModal,
};
